import "../global.css";
import { useFonts } from "expo-font";
import "react-native-reanimated";
import { Stack } from "expo-router";
import * as SplashScreen from "expo-splash-screen";
import { ToastProvider } from "react-native-toast-notifications";
import { StatusBar, View, Platform } from "react-native";
import { Provider } from "react-redux";
import DrawerMenu from "../components/drawer/DrawerMenu";
import FreeTierModal from "../components/modals/FreeTierModal";
import { useFreeTierModal } from "../hooks/useFreeTierModal";
import MobileWebBanner from "../components/web/MobileWebBanner";
import store from "../store";
import { useEffect } from "react";
import { useFCMNotifications } from "../hooks/useFCMNotifications";
import { SafeAreaView } from "react-native-safe-area-context";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import ErrorBoundary from "../components/error-boundary/ErrorBoundary";
import NotificationManager from "../components/notifications/NotificationManager";
import { setupGlobalErrorHandling } from "../utils/crashReporter";

// Prevent the splash screen from auto-hiding before asset loading is complete.
SplashScreen.preventAutoHideAsync();

// Inner component that can use hooks
function AppContent() {
  const { isVisible, limits, hideModal, handleUpgrade } = useFreeTierModal();

  // Initialize notifications unconditionally for now (assume user is logged in or we want the token regardless)
  useFCMNotifications(true);

  return (
    <>
      <StatusBar
        backgroundColor="rgba(19, 121, 162, 1)"
        barStyle="light-content"
        translucent={false}
      />
      <SafeAreaView style={{ flex: 1 }}>
        <Stack
          screenOptions={{
            headerShown: false,
            title: "",
          }}
        >
          <Stack.Screen name="index" />
          <Stack.Screen name="(routes)" options={{ headerShown: false }} />
          <Stack.Screen name="(drawer)" options={{ headerShown: false }} />
        </Stack>
      </SafeAreaView>
      <DrawerMenu />
      <FreeTierModal
        visible={isVisible}
        onClose={hideModal}
        onUpgrade={handleUpgrade}
        limits={limits || undefined}
      />
      {Platform.OS === "web" && <MobileWebBanner />}
      <NotificationManager />
    </>
  );
}

export default function RootLayout() {
  const [loaded, error] = useFonts({
    kawkabBold: require("../assets/fonts/kawkabbBold.ttf"),
    kawkabReg: require("../assets/fonts/kawkabReg.ttf"),
  });

  useEffect(() => {
    setupGlobalErrorHandling();
  }, []);

  // Don't hide splash here - let index.tsx hide it after auth check completes
  // This prevents the flash between Loader → onboarding → login

  if (error) {
    // Font loading error handled silently
  }

  if (!loaded) {
    return null;
  }

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <Provider store={store}>
        <ToastProvider
          placement="top"
          duration={3000}
          animationType="slide-in"
          animationDuration={250}
          successColor="#10B981"
          dangerColor="#EF4444"
          warningColor="#F59E0B"
          normalColor="#6B7280"
          offsetTop={80}
          swipeEnabled={true}
        >
          <ErrorBoundary>
            <AppContent />
          </ErrorBoundary>
        </ToastProvider>
      </Provider>
    </GestureHandlerRootView>
  );
}
